import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION, GET_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION, GET_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATIONS, SAVE_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION } from "../../../data/definitions/discount-group-document-line-item-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupDocumentLineItemRelationMutation, DeleteDiscountGroupDocumentLineItemRelationMutationVariables, DeletionResponse, DiscountGroupDocumentLineItemRelation, DiscountGroupDocumentLineItemRelationInput, DiscountGroupDocumentLineItemRelationSearchInput, GetDiscountGroupDocumentLineItemRelationQuery, GetDiscountGroupDocumentLineItemRelationQueryVariables, GetDiscountGroupDocumentLineItemRelationsQuery, GetDiscountGroupDocumentLineItemRelationsQueryVariables, SaveDiscountGroupDocumentLineItemRelationMutation, SaveDiscountGroupDocumentLineItemRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupDocumentLineItemRelationService extends BaseListService<DiscountGroupDocumentLineItemRelation> implements ICRUD<DiscountGroupDocumentLineItemRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupDocumentLineItemRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupDocumentLineItemRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupDocumentLineItemRelationSearchInput): QueryResult<GetDiscountGroupDocumentLineItemRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupDocumentLineItemRelationsQuery, GetDiscountGroupDocumentLineItemRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupDocumentLineItemRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupDocumentLineItemRelationQuery, GetDiscountGroupDocumentLineItemRelationQueryVariables>(
            GET_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupDocumentLineItemRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupDocumentLineItemRelation as DiscountGroupDocumentLineItemRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupDocumentLineItemRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupDocumentLineItemRelation as DiscountGroupDocumentLineItemRelation);
    }

    async saveItem(item: DiscountGroupDocumentLineItemRelationInput): Promise<DiscountGroupDocumentLineItemRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.DocumentLineItem;

        let validated = await this.systemService.validateObject<DiscountGroupDocumentLineItemRelationInput>(item, "DiscountGroupDocumentLineItemRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupDocumentLineItemRelationMutation, SaveDiscountGroupDocumentLineItemRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupDocumentLineItemRelation as DiscountGroupDocumentLineItemRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupDocumentLineItemRelationMutation, DeleteDiscountGroupDocumentLineItemRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupDocumentLineItemRelation;
    }
}